import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message} from 'antd';
import {doc, getDoc, setDoc} from 'firebase/firestore';
import {db} from '../../config/firebase';

interface SalesContactData {
    phone: string;
    email: string;
    director: string;
    wechat: string;
}

const defaultValues = {
    phone: "792-238-7818",
    email: "xcyvegas888@gmail.com",
    director: "Jessy Xu",
    wechat: "LXExhibition"
};

const SalesContact: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchSalesContact();
    }, []);

    const fetchSalesContact = async () => {
        try {
            const docRef = doc(db, 'config', 'salesContact');
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                form.setFieldsValue(docSnap.data());
            } else {
                // 如果文档不存在，使用默认值并创建文档
                form.setFieldsValue(defaultValues);
                await setDoc(docRef, defaultValues);
            }
        } catch (error) {
            console.error('Error fetching sales contact:', error);
            message.error('Failed to load sales contact information');
            form.setFieldsValue(defaultValues);
        }
    };

    const handleSubmit = async (values: SalesContactData) => {
        setLoading(true);
        try {
            const docRef = doc(db, 'config', 'salesContact');
            await setDoc(docRef, values);
            message.success('Sales contact information updated successfully');
        } catch (error) {
            console.error('Error updating sales contact:', error);
            message.error('Failed to update sales contact information');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto">
            <h1 className="text-2xl font-bold mb-6">Sales Contact Information</h1>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                className="bg-white p-6 rounded-lg shadow-sm"
            >
                <Form.Item
                    label="Sales Director"
                    name="director"
                    rules={[{required: true, message: 'Please input sales director name'}]}
                >
                    <Input placeholder="Enter sales director name"/>
                </Form.Item>

                <Form.Item
                    label="Phone Number"
                    name="phone"
                    rules={[{required: true, message: 'Please input phone number'}]}
                >
                    <Input placeholder="Enter phone number"/>
                </Form.Item>

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        {required: true, message: 'Please input email'},
                        {type: 'email', message: 'Please enter a valid email'}
                    ]}
                >
                    <Input placeholder="Enter email address"/>
                </Form.Item>

                <Form.Item
                    label="WeChat ID"
                    name="wechat"
                    rules={[{required: true, message: 'Please input WeChat ID'}]}
                >
                    <Input placeholder="Enter WeChat ID"/>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Save Changes
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default SalesContact;
